import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";

export enum KeywordsInsightsDirection {
  OUTBOUND = "OUTBOUND",
  INBOUND = "INBOUND",
}

export const ExpressionRule = Type.Object({
  expression: Type.String(),
  caseSensitive: Type.Boolean(),
  description: Type.Optional(Type.String()),
  max: Type.Number(),
  type: Type.Literal("expression"),
});

export const KeywordInsightsCampaignCondition = Type.Union([
  Type.Object({ type: Type.Literal("user"), userId: Type.Array(Type.String()) }),
  Type.Object({ type: Type.Literal("group"), groupId: Type.Array(Type.String()) }),
  Type.Object({
    type: Type.Literal("direction"),
    direction: Type.Union([Type.Literal(KeywordsInsightsDirection.OUTBOUND), Type.Literal(KeywordsInsightsDirection.INBOUND)]),
  }),
  ExpressionRule,
]);

export type ExpressionRule = TypeBoxToType<typeof ExpressionRule>;

export const KeywordInsightsCampaignType = Type.Object({
  _id: Type.String(),
  orgId: Type.String(),
  name: Type.String(),
  description: Type.Optional(Type.String()),
  conditions: Type.Array(KeywordInsightsCampaignCondition),
  deletedAt: Type.Optional(Type.String()),
  createdAt: Type.Optional(Type.String()),
  updatedAt: Type.Optional(Type.String()),
});

export type KeywordInsightsCampaignType = TypeBoxToType<typeof KeywordInsightsCampaignType>;
export type KeywordInsightsCampaignCondition = KeywordInsightsCampaignType["conditions"][number];
